import { DateTime } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getAssetTypeLabel } from "../shared/constants/managedSurveyAssetTypes";
import { FormRow } from "../shared/FormLayout/FormRow";
import { assetTypeFieldMapping, SurveyableAsset } from "../shared/interfaces/SurveyableAsset";
import { AssetTypeKeys } from "./models/AssetTypeKeys";

interface SwitchgearMetadataProps {
  switchgear: SurveyableAsset;
}

export function SwitchgearMetadata({ switchgear }: SwitchgearMetadataProps) {
  const { t } = useTranslation();
  const formattedInstallDate = useMemo(() => {
    if (!switchgear.installDate) {
      return null;
    }

    const datetime =
      typeof switchgear.installDate === "string"
        ? DateTime.fromISO(switchgear.installDate)
        : DateTime.fromJSDate(switchgear.installDate);

    return datetime.toFormat("dd-MMMM-yyyy");
  }, [switchgear.installDate]);

  const assetType = getAssetTypeLabel(switchgear.assetType) as AssetTypeKeys;
  const fieldsToRender = assetTypeFieldMapping[assetType] || [];

  return (
    <>
      {fieldsToRender.includes("manufacturer") && (
        <FormRow label={t("switchgear.manufacturer")} value={switchgear.switchGearManufacturer} />
      )}
      {fieldsToRender.includes("type") && <FormRow label={t("switchgear.type")} value={switchgear.switchGearType} />}
      {fieldsToRender.includes("ratedVoltage") && (
        <FormRow label={t("switchgear.ratedVoltage")} value={switchgear.ratedVoltage} />
      )}
      {fieldsToRender.includes("operatingVoltage") && (
        <FormRow label={t("switchgear.operatingVoltage")} value={switchgear.operatingVoltage} />
      )}
      {fieldsToRender.includes("insulation") && (
        <FormRow
          label={t("switchgear.insulation")}
          value={switchgear.insulation ? t(`UTP2.insulationType.${switchgear.insulation}`) : null}
        />
      )}
      {fieldsToRender.includes("installDate") && (
        <FormRow label={t("switchgear.installDate")} value={formattedInstallDate} />
      )}
    </>
  );
}
